import React from "react";
import { CommonCell } from "components";

export default function ExpertiseDisplay(props) {
    return <CommonCell {...props} collection="openings" field="expertise" />;
}
